export class CashRegisterLoginVendorHandleRequest {
    cashRegisterId?: number;
    requestData?: string;
    responseData?: string;
}  